import Login from "./components/login/Login";
import Header from "./components/header/Header";
import { Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import { auth } from "./firebase";
import { useAuth } from "./context/GlobalState";
import Home from "./components/home/Home";
import Checkout from "./components/checkout/Checkout";
import Payment from "./components/payment/Payment";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PageNotFount from "./components/PageNotFount";
import Orders from "./components/order/Orders";


function App() {
  const { dispatch } = useAuth();
  
  const stripePromise = loadStripe(
      "pk_test_51R5b7HGgwdkoFxjS4QYPc7XLkJszr0tvqNvc97l7pRDMxKwB3mHc0OlMgSi11589JXOraHBuwX5Avp8e79kFc9pF00DgOJgRWZ"
    );

  useEffect(() => {
    auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        dispatch({
          type: "SET_USER",
          user: authUser,
        });
      } else {
        dispatch({
          type: "SET_USER",
          user: null,
        });
      }
    });
  }, []);

  return (
    <div className="App">
   
      <Routes>
      <Route path="/" element={
        <>
      <Header />
      <Home /> 
      </>
      } />
        <Route path="/login" element={<Login /> } />

        <Route path="/checkout" element={
          <>
          <Header />
          <Checkout />
          </>
           } />

        <Route path="/payment" element={
          <>
          <Header />
          <Elements stripe={stripePromise}>
          <Payment />

          </Elements>
          </>
           } />
        <Route path="*" element={<PageNotFount />}/>
        <Route path="/orders" element={
          <>
          <Header />
          <Orders />
          </>
          }/>

      </Routes>
    </div>
  );
}

export default App;
